import React from "react"

import {
	GridColDef,
} from "@mui/x-data-grid"

import {
	AssetMatchBrandWithImage,
	OrderType,
	PaginatedResponse, SearchFilter,
} from "models"
import {
	PageSectionTitle,
	SbPaginatedDatagrid,
} from "components/commons"

import getTableColumns, {DashboardCompatibleAssetsColumnInterface} from "./table-columns"
import {AssetService} from "../../../services/asset.service";
import {MatesComponent, MatesComponentState} from "../../mates-component";
import withUseRouter, {UseRouterParams} from "../../../services/router";

interface DashboardCompatibleAssetsProps extends UseRouterParams
{
	data: PaginatedResponse<AssetMatchBrandWithImage> | null

	pagination: SearchFilter
	onPaginationChanged: (pageId: number, pageSize: number) => void
	onSortChanged: (orderBy: string|null, orderType: OrderType|null) => void

	likes: string[]

	getLikes: () => void
}
interface DashboardCompatibleAssetsState extends MatesComponentState
{
}
class DashboardCompatibleAssets extends React.Component<DashboardCompatibleAssetsProps, DashboardCompatibleAssetsState>
	implements DashboardCompatibleAssetsColumnInterface
{
	private readonly columns: GridColDef[]
	private readonly matesComponent: MatesComponent<DashboardCompatibleAssetsProps, DashboardCompatibleAssetsState> = new MatesComponent(this)

	constructor(props: DashboardCompatibleAssetsProps)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
		}

		this.columns = getTableColumns(this)
	}

	getLikes(): string[] {
		return this.props.likes;
	}

	toggleLike(id: string, isLike: boolean): void {
		isLike ?
			AssetService.removeFromFavourite(id, this.addOrRemoveLikeCallback, this.matesComponent.onException)
			:
			AssetService.addToFavourite(id, this.addOrRemoveLikeCallback, this.matesComponent.onException)
	}

	private addOrRemoveLikeCallback = (response: any) => {
		if(response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.props.getLikes()
	}


	render()
	{
		return (
			<>
				<PageSectionTitle title="Immobili compatibili (tutte le insegne)" variant="dashboard" />

				<SbPaginatedDatagrid
					columns={this.columns}
					data={this.props.data}
					pagination={this.props.pagination}
					onPaginationChanged={this.props.onPaginationChanged}
					onSortChanged={this.props.onSortChanged}
				/>
			</>
		)
	}
}

export default withUseRouter(DashboardCompatibleAssets)
